const api = {
    ip:"http://118.89.87.102:8080", // 请求数据前缀 ip
    imgSrc:"/jeecg-boot/sys/common/static/"
};

export default {
    api
}



//////////////////
// WEBPACK FOOTER
// ./static/ipConfig.js
// module id = null
// module chunks = 